import React, { Fragment } from "react";

export function Shimmer(props) {
  const { className="", isLoading, width, height, backgroundColor, shimmerColor, children, testId="" } = props;
  const wrapperStyle = isLoading ? {"display": "none"}  : {};
  const shimmerWidth = width ? { "--element-width": width} : {};
  const shimmerHeight = height ? { "--element-height": height} : {};
  const shimmerColorStyle = shimmerColor ? {"--shimmer-color": shimmerColor} : {};
  const backgroundColorStyle = backgroundColor ? {"--background-color": backgroundColor} : {};
  const shimmerStyles = { ...shimmerWidth, ...shimmerHeight, ...backgroundColorStyle, ...shimmerColorStyle };

  return (
    <Fragment>
      { isLoading ? 
        (
        <div className={`spinner--shimmer ${className}`} style={shimmerStyles} data-testid={`shimmer${testId ? "-" + testId : ""}`}>
          <div className="shimmer__background"></div>
         </div>
        ) : null }
      <div style={wrapperStyle}>
          {children}
      </div>
    </Fragment>
  );
}

export function shimmerWrapper(WrappedComponent) {
  return (props) => {
    const { showShimmer, shimmerProps, ...componentProps } = props;

    if (showShimmer) {
      return (
        <>
          <Shimmer 
            className={`${shimmerProps.classList || ""}`}
            isLoading={true}
            height={shimmerProps.height}
            {...shimmerProps}
          />
        </>
      );
    }

    return (
      <WrappedComponent {...componentProps } />
    )
  }
}

export default Shimmer;
